/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// page
import Page from 'material/structure/page/page';
// group
import Group from 'material/group/group';
// copy
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
// ctas
import SignInCTA from 'material/ctas/signin/signin';
import SocialLinks from 'material/ctas/social/social';
// styles
// import injectSheet from 'react-jss';
// import styles from 'pages/auth/requestsubmitted/requestsubmitted_styles';




/* ========== ~~~~~~~~~~ PAGE : REQUEST SUBMITTED : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class RequestSubmittedPage extends Component {
    render() {
        return(
            <Page name={`requestsubmitted`}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Request Submitted</h2>
                        </Title>
                        <BodyCopy>
                            <p>Thank you for requesting a demo, We're excited about working with you.</p>
                            <p>Our team is reviewing the submission and we will contact you soon.</p>
                        </BodyCopy>
                        <SocialLinks />
                    </Copy>
                </Group>
                <Group name={`callout`}>
                    <SignInCTA copy={'Already have an account?'} />
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default RequestSubmittedPage;
// export default injectSheet(styles)(RequestSubmittedPage);
